import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PricingPlans } from "@/components/PricingPlans";

export function PricingPage() {
  return (
    <div className="min-h-screen bg-parchment">
      <Navbar />
      <main className="pt-24">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mb-16">
            <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-4 block">
              Planes y Membresías
            </span>
            <h1 className="text-5xl md:text-8xl font-display font-black uppercase text-ink leading-none italic mb-6">
              Escala tu <br /> 
              <span className="text-stroke-ink">Potencial</span>
            </h1>
            <p className="text-xl font-serif italic text-ink/60 max-w-2xl leading-relaxed">
              Elija el nivel de soporte y herramientas que mejor se adapte a su volumen de negocio. Desde el inicio hasta la consolidación regional.
            </p>
          </div>
          <PricingPlans />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default PricingPage;
